import './Logo.css'

import React from 'react'

const Logo = () => <div className="footer-logo" />

export default Logo
